import React, { useState, useEffect, useMemo } from "react";

import Card from "../../components/Card";
import { useNavigate } from "react-router-dom";
import { Row, Col, OverlayTrigger, Tooltip, Button, Form, Dropdown } from 'react-bootstrap'
import DashboardService from "../../services/pbumku/DashboardService";
import { Pagination } from "react-bootstrap";

const ReportSMKHP = () => {
  let RepService = useMemo(() => new DashboardService(), []);
  const [reports, setReports] = useState([]);
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Variabel untuk baca tanggal default
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-11
  const [startOfMonth, setStartOfMonth] = useState(new Date(year, month, 1));
  const [endOfMonth, setEndOfMonth] = useState(new Date(year, month + 1, 0)); // 0 = last day of previous month

  const formatDate = (date, isEndOfDay = false) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // bulan dimulai dari 0
    const dd = String(date.getDate()).padStart(2, '0');
    const time = isEndOfDay ? '23:59:59' : '00:00:00';
    return `${yyyy}-${mm}-${dd} ${time}`;
  };

  const formatDateInput = (date) => {
    const offset = date.getTimezoneOffset(); // dalam menit
    const localDate = new Date(date.getTime() - offset * 60 * 1000);
    return localDate.toISOString().slice(0, 10);
  };

  const bulanMap = {
    Januari: 0,
    Februari: 1,
    Maret: 2,
    April: 3,
    Mei: 4,
    Juni: 5,
    Juli: 6,
    Agustus: 7,
    September: 8,
    Oktober: 9,
    November: 10,
    Desember: 11,
  };

  const englishToIndonesianMonth = {
    January: "Januari",
    February: "Februari",
    March: "Maret",
    April: "April",
    May: "Mei",
    June: "Juni",
    July: "Juli",
    August: "Agustus",
    September: "September",
    October: "Oktober",
    November: "November",
    December: "Desember",
  };

  // Variabel untuk baca tanggal default
  // const [selectedBulan, setSelectedBulan] = useState(today.toLocaleString("id-ID", { month: "long" }) + " " + today.toLocaleString("default", { year: "numeric" }));
  const [selectedBulan, setSelectedBulan] = useState(today.toLocaleString("id-ID", { month: "long" }));
  const [selectedTahun, setSelectedTahun] = useState(today.toLocaleString("default", { year: "numeric" }));

  // varibel untuk label bulan tahun
  const [bulanTahun, setBulanTahun] = useState([]);

  // variabel baca upt
  const [kdUPT, setKdUPT] = useState(localStorage.getItem("kdUnit"));

  // limit per page
  const [limit, setLimit] = useState(20); // jumlah data per halaman

  // nama UPT
  const [namaUPT, setNamaUPT] = useState(null);

  // check yang login, dari upt atau dari pusat
  const [isVisibleUpt, setIsVisibleUpt] = useState(false);

  // varibel Range Periode
  // const [rangePeriode, setRangePeriode] = useState(`Bulan ${selectedBulan} Tahun ${selectedTahun}`);
  const [rangePeriode, setRangePeriode] = useState(`Bulan ${selectedBulan} Tahun ${selectedTahun}`);


  // template startDate dan endDate
  const [tempStartDate, setTempStartDate] = useState(formatDateInput(startOfMonth));
  const [tempEndDate, setTempEndDate] = useState(formatDateInput(endOfMonth));

  const [tahuns, setTahuns] = useState([]);

  const [jumfreq, setJumfreq] = useState(0); // jumlah data frequensi
  const [jumVol, setJumVol] = useState(0); // jumlah data volume
  const [nilaiIDR, setNilaiIDR] = useState(0); // Nilai Rupiah
  const [nilaiUSD, setNilaiUSD] = useState(0); // Nilai USD 

  // variabel click export to excell
  const [isDownloading, setIsDownloading] = useState(false);

  // alias header
  const headerAliases = {
    tanggal_aju: "tgl aju",
    tanggal_berangkat: "tgl brkt",
    tanggal_smkhp: "tgl smkhp",
    nomor_aju: "no aju",
    no_hc: "no smkhp",
    nama_upt: "upt",
    nama_trader: "trader",
    alamat_trader: "alamat trader",
    nama_upi: "upi",
    alamat_upi: "alamat upi",
    nama_partner: "partner",
    alamat_partner: "alamat partner",
    pel_asal: "pel asal",
    pel_muat: "pel muat",
    pel_bongkar: "pel bongkar",
    negara_tujuan: "negara",
    kel_ikan: "kel ikan",
    nm_dagang: "nm dagang",
    nm_latin: "nm latin",
    nilai_rupiah: "rp",
    nilai_dolar: "usd",
    kurs_usd: "kurs",
    cara_angkut: "angkut",
    alat_angkut: "alat",
    voyage: "voyage"
  };

  useEffect(() => {
    // sementara
    // const keys = Object.keys(localStorage);
    // keys.forEach((key) => {
    //   const value = localStorage.getItem(key);
    //   console.log(`${key}: ${value}`);
    // });

    getReports(currentPage, limit);
    getNamaUPT();
    getBulanTahun();
    getTahun();
    getJumlahFrequensi();
    getJumlahVolume();
    getNilai();
  }, [limit, currentPage, startOfMonth, endOfMonth]);


  useEffect(() => {
    let roleUser = localStorage.getItem('role')
    if (roleUser !== "1" && roleUser !== "2" && roleUser !== "3" && roleUser !== "7") {
      navigate('/dashboard')
    }
  }, [navigate]);

  const getReports = async (page, limit) => {
    try {
      const response = await RepService.getReportSMKHP(kdUPT, page, limit, formatDate(startOfMonth), formatDate(endOfMonth, true));
      setReports(response.data.data);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Gagal mengambil report:", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    getReports(pageNumber);
  };

  // Nama UPT
  const getNamaUPT = async () => {
    const cleanedKdUPT = kdUPT.trim();
    const excludedUPTs = new Set(['00.1', '00.2', '00.3']);
    const isExcluded = excludedUPTs.has(cleanedKdUPT);

    if (!isExcluded) {
      try {
        const response = await RepService.getNamaUPT(cleanedKdUPT);
        setNamaUPT(response.data.NM_PENDEK);
        setIsVisibleUpt(true);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const renderPagination = () => {
    const paginationItems = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, currentPage + 2);

    if (currentPage <= 3) {
      endPage = Math.min(totalPages, maxPagesToShow);
    }

    if (currentPage > totalPages - 3) {
      startPage = Math.max(1, totalPages - maxPagesToShow + 1);
    }

    // << Prev
    paginationItems.push(
      <Pagination.Prev
        key="prev"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
    );

    // First page
    if (startPage > 1) {
      paginationItems.push(
        <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
          1
        </Pagination.Item>
      );
      if (startPage > 2) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
      }
    }

    // Middle pages
    for (let number = startPage; number <= endPage; number++) {
      paginationItems.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    // Last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
      }
      paginationItems.push(
        <Pagination.Item key={totalPages} onClick={() => handlePageChange(totalPages)}>
          {totalPages}
        </Pagination.Item>
      );
    }

    // Next >>
    paginationItems.push(
      <Pagination.Next
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    );

    return paginationItems;
  };

  // Format Tanggal Indonesia
  const formatTanggalIndonesia = (tanggalStr) => {
    const bulanIndo = [
      "Januari", "Februari", "Maret", "April", "Mei", "Juni",
      "Juli", "Agustus", "September", "Oktober", "November", "Desember"
    ];

    const tanggal = new Date(tanggalStr);
    const hari = String(tanggal.getDate()).padStart(2, '0');
    const bulan = bulanIndo[tanggal.getMonth()];
    const tahun = tanggal.getFullYear();

    return `${hari} ${bulan} ${tahun}`;
  };

  const handleSelect = (value) => {
    setSelectedBulan(value);

    const bulanMap = {
      Januari: 0, Pebruari: 1, Maret: 2, April: 3, Mei: 4, Juni: 5,
      Juli: 6, Agustus: 7, September: 8, Oktober: 9, November: 10, Desember: 11,
    };

    const bulan = bulanMap[value];
    const tahun = parseInt(selectedTahun);

    if (bulan === undefined || isNaN(tahun)) return;

    setStartOfMonth(new Date(tahun, bulan, 1));
    setEndOfMonth(new Date(tahun, bulan + 1, 0));
    setRangePeriode(`Bulan ${value} Tahun ${tahun}`);
  };

  const handleClickButton = () => {
    if (!tempStartDate || !tempEndDate) {
      alert("Harap isi kedua tanggal.");
      return;
    }

    const tglAwal = new Date(tempStartDate);
    const tglAkhir = new Date(tempEndDate);

    // Validasi akhir >= awal
    if (tglAkhir < tglAwal) {
      alert("Tanggal akhir harus lebih besar atau sama dengan tanggal awal.");
      return;
    }

    // Validasi tahun sama
    if (tglAwal.getFullYear() !== tglAkhir.getFullYear()) {
      alert("Periode harus dalam tahun yang sama.");
      return;
    }

    // ✅ Baru ubah state utama → trigger useEffect
    setStartOfMonth(tglAwal);
    setEndOfMonth(tglAkhir);
    setRangePeriode(
      `${formatTanggalIndonesia(tglAwal)} s/d ${formatTanggalIndonesia(tglAkhir)}`
    );
  };

  const handleSelectTahun = (value) => {
    setSelectedTahun(value);
    setStartOfMonth(new Date(`${value}-01-01`));
    setEndOfMonth(new Date(`${value}-12-31`));
    setRangePeriode(`Tahun ${selectedTahun}`)
  };

  const getBulanTahun = async () => {
    const response = await RepService.getBulanTahun2()
    setBulanTahun(response.data)
  };

  const getTahun = async () => {
    const response = await RepService.getTahun()
    setTahuns(response.data)
  };

  const getJumlahFrequensi = async () => {
    const response = await RepService.getJumlahFrequensi(kdUPT, formatDate(startOfMonth), formatDate(endOfMonth, true))
    setJumfreq(response.data)
    // if (response.data === 0) {
    //   setIsNol(true)
    // }
  };

  const getJumlahVolume = async () => {
    const response = await RepService.getJumlahVolume(kdUPT, formatDate(startOfMonth), formatDate(endOfMonth, true))
    setJumVol(response.data.totalVolume)
  };

  const getNilai = async () => {
    const response = await RepService.getJumlahNilai(kdUPT, formatDate(startOfMonth), formatDate(endOfMonth, true))
    setNilaiIDR(response.data.totalNilaiIDR)
    setNilaiUSD(response.data.totalNilaiUSD)
  };

  const downloadExcel = async () => {
    setIsDownloading(true);
    try {
      const kdUPT = localStorage.getItem("kdUnit");
      const response = await RepService.getExcell(
        kdUPT,
        formatDate(startOfMonth),
        formatDate(endOfMonth, true)
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `report_ekspor_${rangePeriode}.xlsx`;
      link.click();
    } catch (error) {
      console.error("Gagal mengunduh Excel:", error);
    } finally {
      setIsDownloading(false);
    }
  };


  function formatDateTime(value) {
    const date = new Date(value);
    if (isNaN(date)) return "-";

    const pad = (num) => String(num).padStart(2, '0');

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }


  return (
    <>
      <Row style={{ position: 'relative', top: '-20px' }}>
        {/* Header */}
        <Col md="12">
          <div className="iq-navbar-header mb-4">
            <Row className="align-items-center">
              {/* Kiri: Judul dan Info */}
              <Col lg={8} md={12} className="mb-3 mb-lg-0">
                <h1 className="text-white">Report SMKHP</h1>
                <h2 className="text-white mb-0">{!isVisibleUpt ? `BPPMHKP` : namaUPT}</h2>
                <h3 className="text-light mt-0">
                  {/* {xAxis === 1 ? `Bulan ${selectedBulan}` : `Tahun ${selectedTahun}`} */}
                  {rangePeriode}
                </h3>
              </Col>

              {/* Kanan: Form dan Dropdown */}
              <Col lg={4} md={12}>
                <Form.Group className="form-group mb-3">
                  <Form.Label htmlFor="exampleInputdate" className="text-white">
                    Periode
                  </Form.Label>
                  <div className="d-flex gap-2 flex-nowrap">
                    <Form.Control
                      type="date"
                      id="tanggalAwal"
                      value={tempStartDate}
                      onChange={(e) => setTempStartDate(e.target.value)}
                      style={{
                        backgroundColor: 'transparent',
                        border: '1px solid #ccc',
                        minWidth: '140px',
                        color: 'white',
                      }}
                    />
                    <Form.Control
                      type="date"
                      id="tanggalAkhir"
                      value={tempEndDate}
                      onChange={(e) => setTempEndDate(e.target.value)}
                      style={{
                        backgroundColor: 'transparent',
                        border: '1px solid #ccc',
                        minWidth: '140px',
                        color: 'white',
                      }}
                    />
                    <Button type="button" variant="primary" className="whitespace-nowrap" onClick={handleClickButton}>
                      Submit
                    </Button>
                  </div>
                </Form.Group>

                <div className="d-flex gap-3 flex-wrap">
                  <div className="d-flex align-items-center text-white">
                    Bulan
                    {/* <Dropdown onSelect={handleSelect} className="ms-2"> */}
                    <Dropdown className="ms-2">
                      <Dropdown.Toggle as={Button} variant="outline-light" size="sm">
                        {selectedBulan}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {bulanTahun.map((bt) => {
                          const indonesianMonth = englishToIndonesianMonth[bt.namaBulan];
                          const tahunLabel = bt.year;

                          return (
                            <Dropdown.Item
                              key={`${bt.noMonth}-${bt.year}`}
                              onClick={() => {
                                setSelectedBulan(indonesianMonth);
                                setSelectedTahun(tahunLabel);
                                const bulan = bulanMap[indonesianMonth];
                                const tahun = parseInt(tahunLabel);
                                setStartOfMonth(new Date(tahun, bulan, 1));
                                setEndOfMonth(new Date(tahun, bulan + 1, 0));
                                setRangePeriode(`Bulan ${indonesianMonth} Tahun ${tahun}`);
                              }}
                            >
                              {`${indonesianMonth} ${tahunLabel}`}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  <div className="d-flex align-items-center text-white">
                    Tahun
                    <Dropdown onSelect={handleSelectTahun} className="ms-2">
                      <Dropdown.Toggle as={Button} variant="outline-light" size="sm">
                        {selectedTahun}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {tahuns.map((tahun) => (
                          <Dropdown.Item key={tahun.year} eventKey={tahun.year}>
                            {tahun.year}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* Summary dan Export */}
      <Row className="mb-0 mt-3">
        <Col md={12}>
          <Card className="shadow-sm border-0 bg-light">
            <Card.Body>
              <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">

                {/* Badge Summary */}
                <div className="d-flex flex-wrap gap-2 align-items-center">
                  <div className="d-flex">
                    <span className="badge bg-primary px-3 py-2 fs-6 fw-semibold rounded-start">
                      Jumlah Permohonan
                    </span>
                    <span className="badge bg-secondary px-3 py-2 fs-6 fw-semibold rounded-end">
                      {jumfreq}
                    </span>
                  </div>

                  <div className="d-flex">
                    <span className="badge bg-success px-3 py-2 fs-6 fw-semibold rounded-start">
                      Total Volume
                    </span>
                    <span className="badge bg-light text-dark px-3 py-2 fs-6 fw-semibold border border-success rounded-end">
                      {`${new Intl.NumberFormat('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(jumVol / 1000)} TON`}
                    </span>
                  </div>

                  <div className="d-flex">
                    <span className="badge bg-warning text-dark px-3 py-2 fs-6 fw-semibold rounded-start">
                      Nilai Rupiah
                    </span>
                    <span className="badge bg-light text-dark px-3 py-2 fs-6 fw-semibold border border-warning rounded-end">
                      Rp {`${new Intl.NumberFormat('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(nilaiIDR)}`}
                    </span>
                  </div>

                  <div className="d-flex">
                    <span className="badge bg-info text-dark px-3 py-2 fs-6 fw-semibold rounded-start">
                      Nilai Dollar
                    </span>
                    <span className="badge bg-light text-dark px-3 py-2 fs-6 fw-semibold border border-info rounded-end">
                      $ {`${new Intl.NumberFormat('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(nilaiUSD)}`}
                    </span>
                  </div>
                </div>

                {/* Tombol Unduh Excel */}
                <Button
                  variant="outline-success"
                  className="px-3 py-2 d-flex align-items-center"
                  onClick={downloadExcel}
                  disabled={isDownloading}
                >
                  {isDownloading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Mengunduh...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-file-earmark-excel-fill me-2"></i>
                      Unduh Excel
                    </>
                  )}
                </Button>

              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Tabel */}
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Rincian Report</h4>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive table-responsive-custom">
                {/* <table className="table table-sm table-hover table-striped align-middle small">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Nomor Aju</th>
                      <th>Tanggal Aju</th>
                      <th>Nama UPT</th>
                      <th>Nama Trader</th>
                      <th>Negara Tujuan</th>
                      <th>Netto</th>
                      <th>Jumlah</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reports.length > 0 ? reports.map((report, index) => (
                      <tr key={index}>
                        <td>{(currentPage - 1) * limit + index + 1}</td>
                        <td>{report.nomor_aju}</td>
                        <td>{report.tanggal_aju ? new Date(report.tanggal_aju).toLocaleDateString() : '-'}</td>
                        <td>{report.nama_upt}</td>
                        <td>{report.nama_trader}</td>
                        <td>{report.negara_tujuan}</td>
                        <td>{report.netto?.toLocaleString()}</td>
                        <td>{report.jumlah?.toLocaleString()}</td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan="8" className="text-center">Tidak ada data</td>
                      </tr>
                    )}
                  </tbody>
                </table> */}
                <table className="table table-sm table-hover table-bordered table-striped align-middle small">

                  <thead className="table-light">
                    <tr>
                      <th className="px-3 py-2">#</th>
                      {reports[0] && Object.keys(reports[0]).map((key, i) => (
                        <th key={i} className="px-3 py-2 text-nowrap text-uppercase">
                          {(headerAliases[key] || key.replace(/_/g, " ")).toUpperCase()}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {reports.map((report, index) => (
                      <tr key={index}>
                        <td className="px-3 py-2">{(currentPage - 1) * limit + index + 1}</td>
                        {Object.values(report).map((value, i) => (
                          <td key={i} className="px-3 py-2 text-nowrap">
                            {typeof value === "number"
                              ? value.toLocaleString()
                              : value && !isNaN(Date.parse(value))
                                ? formatDateTime(value)
                                : value || "-"}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="mt-3 align-items-center">
        <Col md="6" className="d-flex justify-content-center justify-content-md-start mb-2 mb-md-0">
          <Pagination>{renderPagination()}</Pagination>
        </Col>
        <Col md="6" className="d-flex align-items-center gap-2 justify-content-center justify-content-md-end">
          <label className="form-label mb-0 text-nowrap">Baris per halaman:</label>
          <select
            className="form-select form-select-sm w-auto"
            value={limit}
            onChange={(e) => {
              setLimit(parseInt(e.target.value));
              setCurrentPage(1);
            }}
          >
            {[15, 20, 50, 100].map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </Col>
      </Row>
    </>
  );
};

export default ReportSMKHP;
